import { Hidden, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { Contract } from '../../types/contract'
import ContractRow from './ContractRow'
import ContractRowSkeleton from './ContractsRow.skeleton'
import useStyles from './styles/ContractsTable.styles'

interface ContractsTableProps {
  loading: boolean
  data: Contract[]
  reloadData: () => void
  providerCode: string
  providerID: string
  templateID: string
}

export const ContractsTable: React.FC<ContractsTableProps> = ({
  loading,
  data,
  reloadData,
  providerCode,
  providerID,
  templateID
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <Hidden smDown>
          <div>
            <Typography variant="body1">{getTranslate('Channels')}</Typography>
          </div>
          <div>
            <Typography variant="body1">
              {getTranslate('Accommodations')}
            </Typography>
          </div>
          <div>
            <Typography variant="body1">
              {getTranslate('Date Intervals')}
            </Typography>
          </div>
          <div>
            <Typography variant="body1">{getTranslate('Is Active')}</Typography>
          </div>
        </Hidden>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              reloadData()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill(null)
            .map((item, index) => (
              <ContractRowSkeleton
                key={`template-row-skeleton${index.toString()}`}
              />
            ))
        : data.map((singleContract, index) => (
            <ContractRow
              key={singleContract.Title + '-' + index.toString()}
              data={singleContract}
              providerCode={providerCode}
              providerID={providerID}
              templateID={templateID}
            />
          ))}
    </div>
  )
}

export default ContractsTable
